module.exports = __webpack_public_path__ + "static/media/logoMenu.34222110.svg";